import { render, staticRenderFns } from "./PButton.vue?vue&type=template&id=710232c0"
import script from "./PButton.vue?vue&type=script&lang=js"
export * from "./PButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports